import { combineReducers } from '@reduxjs/toolkit';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import authReducer from '../redux/auth/authSlice';

const persistConfig = {
    key: 'frontend-root',
    storage,
};

const rootReducer = combineReducers({
    auth: authReducer,
})

const configurePersistReducer = () => {
    const persistedReducer = persistReducer(persistConfig, rootReducer);
    return persistedReducer;
};

export default configurePersistReducer();